export default __webpack_public_path__ + "static/media/persons.09a32989.svg";